import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {PartnerOffer, PartnersHeaderData} from 'src/app/shared/models/data.model'
import { properties } from 'src/environments/properties';
import { ParamService } from '../../services/param.service';
declare let $: any;
declare let slick: any;


@Component({
  selector: 'app-partnerscarousel',
  templateUrl: './partnerscarousel.component.html',
  styleUrls: ['./partnerscarousel.component.scss']
})
export class PartnerscarouselComponent implements OnInit {

  banner: string;

  @Input() carouselData: any;
  partnerOffers: PartnerOffer[] = [];
  @Input() configObj: any = {
    appName: '',
    programType: ''
  };
  @Input() userInfo: any;
  disableSlickUnifiedBtnUI = false;

  partnersHeaderDisplay: PartnersHeaderData;
  _childComponentsReady = new BehaviorSubject<boolean>(false);

  enablePartnersOffersV2: boolean = false;

  constructor(public elementRef: ElementRef,
    public paramService: ParamService) {
    this.banner = this.paramService.banner;
    const partnerPromotionBannerConfig = properties.featureFlags.partnerPromotionBannerConfig;
        this.enablePartnersOffersV2 = properties.featureFlags.enablePartnersOffersV2 && partnerPromotionBannerConfig[this.banner] === true;
   }

  ngOnInit(): void {
    this.setPartnerOfferData();
  }


  ngAfterViewInit() {
    this._childComponentsReady.subscribe((next) => {
      if (next !== true) {
        return;
      }

      if (!this.partnerOffers || this.partnerOffers.length === 0) {
        return;
      }

      this.initSlick();

    });
  }

  setPartnerOfferData() {
    if (this.carouselData?.partnersInfo) {
      this.partnersHeaderDisplay = {
        title: this.carouselData.title,
        subTitle: this.carouselData.subTitle
      }
      this.partnerOffers = this.carouselData.partnersInfo;
    }

    if (this.partnerOffers?.length > 0) {
      this.sortPartnerOffers(); 
      this._childComponentsReady.next(true);
    }
  }

  initSlick() {
    const elementRef = this.elementRef.nativeElement;
    const activeSlides = {
      "320": 1,
      "660": 2,
      "970": 2,
      "1260": 3,
    };
    const breakpoints = [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: activeSlides["320"],
          slidesToScroll: activeSlides["320"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 660,
        settings: {
          slidesToShow: activeSlides["660"],
          slidesToScroll: activeSlides["660"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 970,
        settings: {
          slidesToShow: activeSlides["970"],
          slidesToScroll: activeSlides["970"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: activeSlides["1260"],
          slidesToScroll: activeSlides["1260"],
          dots: false,
          arrows: true,
        },
      },
    ];

    
    let ele = $(elementRef).find("#partners-offer-carousel")
    $(ele)
      .slick({
        lazyLoad: "ondemand",
        tail: true,
        dots: false,
        infinite: false,
        cssEase: "linear",
        speed: 300,
        centerMode: false,
        variableWidth: true,
        variableHeight: true,
        mobileFirst: true,
        accessibility: true,
        swipe: true,
        swipeToSlide: false,
        // prevArrow: false,//Added
        ...(this.disableSlickUnifiedBtnUI === false && {
          nextArrow:
            '<button type="button" aria-label="Go to the next slide" class="slick-next coupons-carousel-module__next-btn"></button>',
        }),
        ...(this.disableSlickUnifiedBtnUI === false && {
          prevArrow:
            '<button type="button" aria-label="Go to the previous slide" class="slick-prev coupons-carousel-module__prev-btn"></button>',
        }),
        responsive: breakpoints
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        if (nextSlide !== 0) {
          $("#partners-offer-carousel .slick-prev").removeClass("mask");
        } else {
          $("#partners-offer-carousel .slick-prev").addClass("mask");
        }

        if (currentSlide < nextSlide) {
          // Next Button pressed
          const newSlickIndex =
            Number(
              $(".slick-active", $(elementRef)).last().attr("data-slick-index")
            ) + 1;
          const focusSlide = $(
            '.slick-list .slick-slide[data-slick-index="' +
            newSlickIndex +
            '"]',
            $(elementRef)
          );

          if (focusSlide) {
            setTimeout(function () {
              focusSlide.eq(0).focus();
            }, 300);
          }
        } else {
          // Prev Button pressed
          const newSlickIndex =
            Number(
              $(".slick-active", $(elementRef)).first().attr("data-slick-index")
            ) - 1;
          const focusSlide = $(
            '.slick-list .slick-slide[data-slick-index="' +
            newSlickIndex +
            '"]',
            $(elementRef)
          );

          if (focusSlide) {
            setTimeout(function () {
              focusSlide.eq(0).focus();
            }, 300);
          }
        }
      })
    $("#partners-offer-carousel .slick-prev").addClass("mask");

  }

  sortPartnerOffers(): void {
    this.partnerOffers.sort((a, b) => {
      const aOrder = Number(a.displayOrder);
      const bOrder = Number(b.displayOrder);
      if (isNaN(aOrder) || isNaN(bOrder)) {
        return 0;
      }
      return aOrder - bOrder;
    });
  }
}
